import { render, staticRenderFns } from "./overdue.vue?vue&type=template&id=0bbe5cc9&scoped=true&"
import script from "./overdue.vue?vue&type=script&lang=ts&"
export * from "./overdue.vue?vue&type=script&lang=ts&"
import style0 from "./overdue.vue?vue&type=style&index=0&id=0bbe5cc9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe5cc9",
  null
  
)

export default component.exports